module.exports = __webpack_public_path__ + "static/img/daikuan.ffa33140.png";